import { createContext } from "react";
import { Artist } from "../../types/Artist";
import { ArtistVector } from "../../types/ArtistVector";

export interface VectorModalContextType {
    vector: ArtistVector | undefined;
    setVector: (vector: ArtistVector) => void;
    vectorModalOpen: boolean;
    setVectorModalOpen: (open: boolean) => void;
    applyVector: (artist: Artist | undefined) => void;
    artist: Artist | undefined;
    handleSave: () => void;
}

const VectorModalContext = createContext<VectorModalContextType | undefined>(undefined);

export default VectorModalContext;